import React from 'react';

/**
 * @deprecated
 * Please use: <Icon icon='icon-key-x' /> Component as an alternative
 */
const WarningIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "8",
  cy: "8",
  r: "8",
  fill: "#FFA800"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.33366 12.9897v-1.9792c0-.0972-.03125-.1788-.09375-.2448s-.13889-.099-.22917-.099h-2c-.09028 0-.17014.0348-.23958.1042-.06945.0695-.10417.1493-.10417.2396v1.9792c0 .0902.03472.1701.10417.2395.06944.0695.1493.1042.23958.1042h2c.09028 0 .16667-.033.22917-.0989.0625-.066.09375-.1476.09375-.2448ZM9.3125 9.40633 9.5 2.93758c0-.08333-.03472-.14583-.10417-.1875-.06944-.05555-.15277-.08333-.25-.08333H6.85417c-.09723 0-.18056.02778-.25.08333-.06945.04167-.10417.10417-.10417.1875l.17708 6.46875c0 .06945.03473.13021.10417.18229.06944.05209.15278.07813.25.07813h1.92708c.09723 0 .17882-.02604.24479-.07813.06598-.05208.10244-.11284.10938-.18229Z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#fff"
}));
var WarningIcon$1 = WarningIcon;

export { WarningIcon$1 as default };
//# sourceMappingURL=WarningIcon.js.map
